import { use } from 'react'

import { SidebarContext } from '#providers/SidebarProvider'
import type { ISidebarContext } from '#providers/SidebarProvider/interfaces'

export function useSidebar(): ISidebarContext {
  const context = use(SidebarContext)
  if (!context) throw new Error('useSidebar must be used within a SidebarProvider')

  return context
}
